module.exports = __webpack_public_path__ + "media/images/landings/promotion_4/img_campaign_txt-84d253b0b9b87587cbcddb7b55c99e6d.png";